/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BabylonValidatorDetailInfo } from '../models/BabylonValidatorDetailInfo';
import type { BabylonValidatorDetailRequest } from '../models/BabylonValidatorDetailRequest';
import type { BabylonValidatorListInfo } from '../models/BabylonValidatorListInfo';
import type { BabylonValidatorListRequest } from '../models/BabylonValidatorListRequest';
import type { BabylonValidatorPowerEventListInfo } from '../models/BabylonValidatorPowerEventListInfo';
import type { BabylonValidatorPowerEventRequest } from '../models/BabylonValidatorPowerEventRequest';
import type { BabylonValidatorProposedBlockListInfo } from '../models/BabylonValidatorProposedBlockListInfo';
import type { BabylonValidatorProposedBlockPageRequest } from '../models/BabylonValidatorProposedBlockPageRequest';
import type { BabylonValidatorStakerListInfo } from '../models/BabylonValidatorStakerListInfo';
import type { BabylonValidatorStakerListRequest } from '../models/BabylonValidatorStakerListRequest';
import type { BabylonValidatorSummaryInfo } from '../models/BabylonValidatorSummaryInfo';
import type { BabylonValidatorUptimeListInfo } from '../models/BabylonValidatorUptimeListInfo';
import type { BabylonValidatorUptimeRequest } from '../models/BabylonValidatorUptimeRequest';
import type { BabylonValidatorVoteListInfo } from '../models/BabylonValidatorVoteListInfo';
import type { BabylonValidatorVoteListRequest } from '../models/BabylonValidatorVoteListRequest';
import type { CommonEmptyRequest } from '../models/CommonEmptyRequest';
import type { ZerogDelegateTrxListInfo } from '../models/ZerogDelegateTrxListInfo';
import type { ZerogDelegateTrxListRequest } from '../models/ZerogDelegateTrxListRequest';
import type { ZerogDelegationActivityChartDailyListInfo } from '../models/ZerogDelegationActivityChartDailyListInfo';
import type { ZerogDelegationBreakdownChartInfo } from '../models/ZerogDelegationBreakdownChartInfo';
import type { ZerogDelegatorValidatorListInfo } from '../models/ZerogDelegatorValidatorListInfo';
import type { ZerogDelegatorValidatorListRequest } from '../models/ZerogDelegatorValidatorListRequest';
import type { ZerogValidatorDelegatorListInfo } from '../models/ZerogValidatorDelegatorListInfo';
import type { ZerogValidatorDelegatorListRequest } from '../models/ZerogValidatorDelegatorListRequest';
import type { ZerogValidatorDetailInfo } from '../models/ZerogValidatorDetailInfo';
import type { ZerogValidatorDetailRequest } from '../models/ZerogValidatorDetailRequest';
import type { ZerogValidatorListInfo } from '../models/ZerogValidatorListInfo';
import type { ZerogValidatorListRequest } from '../models/ZerogValidatorListRequest';
import type { ZerogValidatorSummaryInfo } from '../models/ZerogValidatorSummaryInfo';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class ValidatorControllerService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getValidatorDetail({
        requestBody,
    }: {
        requestBody: (BabylonValidatorDetailRequest | ZerogValidatorDetailRequest),
    }): CancelablePromise<(BabylonValidatorDetailInfo | ZerogValidatorDetailInfo)> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/validator',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getValidatorVoteList({
        requestBody,
    }: {
        requestBody: BabylonValidatorVoteListRequest,
    }): CancelablePromise<BabylonValidatorVoteListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/validator/vote/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getValidatorUptime({
        requestBody,
    }: {
        requestBody: BabylonValidatorUptimeRequest,
    }): CancelablePromise<BabylonValidatorUptimeListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/validator/uptime',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getValidatorSummary({
        requestBody,
    }: {
        requestBody: CommonEmptyRequest,
    }): CancelablePromise<(BabylonValidatorSummaryInfo | ZerogValidatorSummaryInfo)> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/validator/summary',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getValidatorStakerList({
        requestBody,
    }: {
        requestBody: BabylonValidatorStakerListRequest,
    }): CancelablePromise<BabylonValidatorStakerListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/validator/staker/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getValidatorProposedBlockList({
        requestBody,
    }: {
        requestBody: BabylonValidatorProposedBlockPageRequest,
    }): CancelablePromise<BabylonValidatorProposedBlockListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/validator/proposed/block/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getValidatorPowerEventList({
        requestBody,
    }: {
        requestBody: BabylonValidatorPowerEventRequest,
    }): CancelablePromise<BabylonValidatorPowerEventListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/validator/power/event/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getValidatorList({
        requestBody,
    }: {
        requestBody: (BabylonValidatorListRequest | ZerogValidatorListRequest),
    }): CancelablePromise<(BabylonValidatorListInfo | ZerogValidatorListInfo)> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/validator/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getDelegatorValidatorList({
        requestBody,
    }: {
        requestBody: ZerogDelegatorValidatorListRequest,
    }): CancelablePromise<ZerogDelegatorValidatorListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/validator/delegator/validator/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getValidatorDelegatorList({
        requestBody,
    }: {
        requestBody: ZerogValidatorDelegatorListRequest,
    }): CancelablePromise<ZerogValidatorDelegatorListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/validator/delegator/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getDelegationBreakdownChart({
        requestBody,
    }: {
        requestBody: CommonEmptyRequest,
    }): CancelablePromise<ZerogDelegationBreakdownChartInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/validator/delegation/breakdown/chart',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getDelegationActivityChart({
        requestBody,
    }: {
        requestBody: CommonEmptyRequest,
    }): CancelablePromise<ZerogDelegationActivityChartDailyListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/validator/delegation/activity/chart',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getDelegateTrxList({
        requestBody,
    }: {
        requestBody: ZerogDelegateTrxListRequest,
    }): CancelablePromise<ZerogDelegateTrxListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/validator/delegate/trx/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
